import * as actions from './redux/actions';
import * as homeActions from '../home/redux/actions';
import * as paymentActions from '../pb-payment-details/redux/actions';
import * as serviceActions from '../pb-service-list/redux/actions';

import { HeaderThemeThree, LoginModal } from '.';
import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import MainHeader from '../themes/common/header/MainHeader';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../themes/functions/getIcons/getIcons';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

class LanguageSwitch extends Component {
	constructor(props) {
		super(props);
	}

	changeLanguage = lang => {
		i18next.changeLanguage(lang);
		localStorage.setItem('selectedLanguage', lang);
		if (window.location.pathname.indexOf(`/${lang}/`) <= -1) {
			let path = window.location.pathname;
			if (lang === 'en') {
				path = path.replace('/es/', `/${lang}/`).replace('/pasajes-bus', '/bus-tickets');
				// .replace('/pasajes-tren','/train-tickets')
				// .replace('/transfer-aeropuerto','/airport-transfer')
				// .replace('/carga-bip','/bip-recharge')
				// .replace('/viajes-especiales','/private-transport')
				if (window.location.pathname.length < 4) {
					path = path.replace('/es', `/${lang}`);
				}
				this.props.history.push(path);
			} else {
				path = path.replace('/en/', `/${lang}/`).replace('/bus-tickets', '/pasajes-bus');
				// .replace('/train-tickets', '/pasajes-tren')
				// .replace('/airport-transfer', '/transfer-aeropuerto')
				// .replace('/bip-recharge', '/carga-bip')
				// .replace('/private-transport', '/viajes-especiales')
				if (window.location.pathname.length < 4) {
					path = path.replace('/en', `/${lang}`);
				}
				this.props.history.push(path);
			}
		}
	};

	render() {
		return (
			<div
				className={'language-changer-switch font10 ' + (this.props.logoType == 1 ? '' : 'border')}
			>
				<div
					onClick={() => this.changeLanguage('es')}
					className={'language-item ' + (i18next.language == 'es' ? 'active' : '')}
				>
					ES
				</div>
				<div
					onClick={() => this.changeLanguage('en')}
					className={'language-item ' + (i18next.language == 'en' ? 'active' : '')}
				>
					EN
				</div>
			</div>
		);
	}
}

export class TopStrip extends Component {
	static propTypes = {
		actions: PropTypes.object,
		classes: PropTypes.string,
		logoType: PropTypes.number,
		t: PropTypes.func,
		i18n: PropTypes.object,
		onLogoClicked: PropTypes.func,
		data: PropTypes.object,
	};
	constructor(props) {
		super(props);
		this.state = {
			showLoginModal: false,
			showMyAccountDropDown: false,
			showMyTicketsDropDown: false,
			showCancellationModal: false,
			dropMenus: [
				{
					icon: '/svgs/my-account/my-account-white.svg',
					name: 'PROFILE.MY_ACCOUNT',
					path: '',
				},
				{
					icon: '/svgs/my-account/my-trips-white.svg',
					name: 'PROFILE.MY_TRIPS',
					path: '/trips',
				},
				{
					icon: '/svgs/my-account/my-movements-white.svg',
					name: 'PROFILE.MY_MOVEMENTS',
					path: '/transactions',
				},
				{
					icon: '/svgs/my-account/promotions-white.svg',
					name: 'PROFILE.PROMOTIONS',
					path: '/promotions',
				},
				{
					icon: '/svgs/my-account/my-groups-white.svg',
					name: 'PROFILE.MY_GROUPS',
					path: '/groups',
				},
				{
					icon: '/svgs/my-account/logout-white.svg',
					name: 'PROFILE.LOGOUT',
					isLogout: true,
				},
			],
		};
	}

	componentDidMount() {
		document.addEventListener('click', this.handleClickOutside, true);
	}
	componentWillUnmount() {
		document.removeEventListener('click', this.handleClickOutside, true);
	}

	handleClickOutside = event => {
		const domNode = ReactDOM.findDOMNode(this);

		if (!domNode || !domNode.contains(event.target)) {
			this.setState({ showMyAccountDropDown: false, showMyTicketsDropDown: false });
		}
	};

	gotoHome = () => {
		this.props.onLogoClicked();
		window.scrollTo(0, 0);
		if (CommonService.clearSearchFunction) {
			CommonService.clearSearchFunction();
		}
		this.props.actions.setOnwardPbDate(DateService.getTodayString());
		this.props.actions.setReturnPbDate(null);
		this.props.actions.pbSetSourceCity(null);
		this.props.actions.pbSetDestinationCity(null);
		this.props.actions.setServiceListOnward(null);
		this.props.actions.setServiceListReturn(null);
		if (this.props.history) this.props.history.push('/');
	};

	//  Remove My Account
	onMyAccountClick = () => {
		if (CommonService.isLoggedIn(this.props.common.loginData)) {
			this.props.history.push('/my-account');
			//  this.setState({
			//    showMyAccountDropDown: !this.state.showMyAccountDropDown,
			//    showMyTicketsDropDown:false});
		} else {
			this.props.actions.openCloseLoginModal(true);
			this.setState({ showLoginModal: true });
		}
	};

	onMyTicketsClick = () => {
		//  if (CommonService.isLoggedIn(this.props.common.loginData)) {
		//    this.props.history.push('/my-account/trips');
		//  }else{
		this.setState({
			showMyTicketsDropDown: !this.state.showMyTicketsDropDown,
			showMyAccountDropDown: false,
		});
		//  }

		//  } else {
		//    this.props.actions.openCloseLoginModal(true);
		//    // this.setState({showLoginModal:true})
		//  }
	};

	goToMyAccount = path => {
		this.props.history.push('/my-account' + path);
	};

	menuItemClick = item => {
		if (item.name != 'PROFILE.LOGOUT') {
			this.goToMyAccount(item.path);
		} else {
			CommonService.logout();
			this.props.history.push('/');
		}
		this.setState({ showMyAccountDropDown: false });
	};

	renderMyAccountDropdown = t => {
		return (
			<div className="my-account-dropdown">
				{this.state.dropMenus.map((val, key) => (
					<div
						onClick={() => this.menuItemClick(val)}
						className={
							'my-account-dropitem flex-row ' + (val.name == 'PROFILE.LOGOUT' ? 'logout' : '')
						}
						key={key}
					>
						<span className="menu-icon">
							<img src={val.icon} alt="" />
						</span>
						<span className="menu-name">{t(val.name)}</span>
					</div>
				))}
			</div>
		);
	};

	handleCancelationDisplay = () => {
		this.setState({ showCancellationModal: false });
	};

	renderMyTicketsDropdown = () => {
		return (
			<div className="my-tickets-dropdown">
				<div className="font10 ">
					<div
						onClick={() => this.setState({ showCancellationModal: true })}
						className={'my-tickets-dropitem display-flex margin-bottom-5 '}
					>
						<span className="top-strip-cancel-ticket-icon">
							<img src="/static/images/cancel_ticket_white.svg" />
						</span>
						<span className="menu-name font10">{this.props.t('CANCEL_TICKET.CANCEL_TICKET')}</span>
					</div>

					<div
						className={'my-tickets-dropitem flex-row display-flex'}
						onClick={() => {
							this.props.history.push(
								`/${i18next.language}${i18next.language === 'en' ? '/pages/contact' : '/pages/contact'
								}`,
							);
							this.setState({ showMyTicketsDropDown: false });
						}}
					>
						<span className="top-strip-cancel-ticket-icon">
							<img src="/static/images/contact_us_white.svg" />
						</span>
						<span className="menu-name font10">{this.props.t('HOME.CONTACT_US')}</span>
					</div>
				</div>
			</div>
		);
	};

	renderLogos = operator => {
		console.log('links', { operator });
		if (operator && operator.header_type === 3)
			return <HeaderThemeThree operator={operator} t={this.props.t} />;

		if (operator && operator.header_type === 1) {
			return (
				<a href="/">
					<img
						src={operator.header_logo}
						alt="DIS"
						className="logo"
						id="main-logo"
						// alt={this.props.t('TRANSLATIONS.VIATUR_MAIN_LOGO')}
						style={{
							width: operator.header_logo_width,
							margin: '10px',
							height: 'auto',
						}}
					/>
				</a>
			);
		}
		if (operator && operator.header_type === 2) {
			// const links = JSON.parse(operator.header_links)
			// console({ links })
			return (
				<div>
					{operator.show_top_header ? (
						<div
							style={{
								background: operator.theme_color,
								color: operator.text_color,
								padding: '5px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<div
								style={{
									width: '1040px',
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
								}}
							>
								<div />
								<div style={{ fontSize: '13px', display: 'flex', alignItems: 'center' }}>
									<span style={{ display: 'flex', alignItems: 'center' }}>
										<img
											src="/svgs/phone.svg"
											alt="DIS"
											style={{ height: '20px', width: '20px', marginRight: '3px' }}
										// className="logo"
										// id="main-logo"
										// alt={this.props.t('TRANSLATIONS.MAIN_LOGO')}
										/>
										(+56 9) 4915 6683
									</span>
									<span style={{ padding: '0 10px' }}>|</span>
									<span style={{ display: 'flex', alignItems: 'center' }}>
										<img
											src="/svgs/email-icon.svg"
											alt="DIS"
											style={{ height: '20px', width: '20px', marginRight: '3px' }}

										// className="logo"
										// id="main-logo"
										// alt={this.props.t('TRANSLATIONS.MAIN_LOGO')}
										/>
										ayuda@pasajebus.com
									</span>
								</div>
							</div>
						</div>
					) : null}

					<div
						style={{
							background: operator.theme_color2,
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<div
							style={{
								width: '1040px',
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
							}}
						>
							<a href="/">
								<img
									src={operator.header_logo}
									className="logo2"
									id="main-logo"
									alt={this.props.t('TRANSLATIONS.KUPOS_LOGO2')}
								/>
							</a>
							<div>
								<style>
									a.header_link {'{'}
									{/* border-bottom: 2px; */}
									{/* font-family:  Montserrat_Bold !important; */}
									{'}'}
									a.header_link:hover {'{'}
									border-bottom: 2px solid{' '}
									{operator && operator.button_color ? operator.button_color : ''};
									{/* font-family: Montserrat_SemiBold !important */}
									{'}'}
								</style>

								{operator.show_header_links && operator.header_links
									? operator.header_links.map((val, i) => {
										return (
											<a
												className="header_link"
												style={{
													color: operator.text_color,
													padding: ' 5px 10px',
													fontSize: '15px',
												}}
												href={Object.values(val)}
											>
												{Object.keys(val)}
											</a>
										);
									})
									: null}
							</div>
						</div>
					</div>
				</div>
			);
		}

		return <div style={{ marginTop: '40px' }} />;
	};

	render() {
		const { t } = this.props;
		const operator = CommonService.getLocal('op') || this.props.home.operator;
		const background = operator && operator.operator_name === 'tarapaca' || 'biaggini' && this.props.logoType === 2 ? operator && operator.color_codes && operator.color_codes.header_color : ''
		return (
			<div className={`nav-section home-nav-section common-top-strip ${this.props.classes}`}>
				<div className="header-details"
					style={{ background }}
				>
					<div
					// className={operator && operator.header_type === 1 ? "content-container" : ""}
					>
						<div className="nav-container">
							<div
								style={{ flex: 1 }}
								onClick={() =>
									this.setState({ showMyAccountDropDown: false, showMyTicketsDropDown: false })
								}
							>
								{/* {this.renderLogos(operator)} */}
								<MainHeader
									key={this.props.history.location.pathname}
									history={this.props.history}
									operator={this.props.home.operator}
									loginData={this.props.common.loginData}
									onMyAccountClick={this.onMyAccountClick}
									t={this.props.t}
								/>
							</div>
						</div>
					</div>
					{this.props.children}
				</div>
				{this.props.newSearch}

				{this.props.metaData ? (
					<LoginModal
						showModal={this.props.common.showLoginModal}
						onHide={() => this.props.actions.openCloseLoginModal(false)}
						common={this.props.common}
						pbPaymentDetails={this.props.pbPaymentDetails}
						metaData={this.props.metaData}
						actions={this.props.actions}
						t={this.props.t}
						onLoginSuccess={() => this.props.actions.openCloseLoginModal(false)}
						onSignupSuccess={() => this.props.actions.openCloseLoginModal(false)}
						history={this.props.history}
						operator={this.props.home.operator}
					/>
				) : null}

				{/* {this.props.metaData ? (
                 <CancellationModal
                   showModal={this.state.showCancellationModal}
                   onHide={() => this.handleCancelationDisplay()}
                   common={this.props.common}
                   metaData={this.props.metaData}
                   actions={this.props.actions}
                   history={this.props.history}
                   t={this.props.t}
                 />
               ) : null} */}
			</div>
		);
	}
}

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
		common: state.common,
		pbPaymentDetails: state.pbPaymentDetails,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(
			{ ...actions, ...serviceActions, ...homeActions, ...paymentActions },
			dispatch,
		),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(TopStrip));



// WEBPACK FOOTER //
// ./src/features/common/TopStrip.js